import { SessionStore } from '../../constants';
import { TaskItemStatus } from '../../taskList/constants';
import { Stage, TaskItem } from '../../taskList/interfaces';
import { checkFormsCompleted } from './checkFormsCompleted';

export const isStageCompleted = (items: TaskItem[]): boolean =>
  items.length === items.filter((item) => item.status === TaskItemStatus.COMPLETED).length;

export const expectedTimeToComplete = (stages: Stage[]): string => {
  let duration = 0;
  stages.forEach((stage) => {
    if (stage.duration) duration += stage?.duration;
  });
  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;
  let combineTime = '';
  if (hours) {
    if (hours === 1) combineTime = `${hours} hour`;
    else combineTime = `${hours} hours`;
  }
  if (minutes) {
    if (minutes === 1) combineTime = `${combineTime} ${minutes} minute`;
    else combineTime = `${combineTime} ${minutes} minutes`;
  }
  return combineTime;
};

export const filterStageList = (stageList: Stage[]): Stage[] => {
  const currentWorkflowItems = sessionStorage.getItem(SessionStore.currentWorkflowItem);
  if (currentWorkflowItems) {
    const workflowItem = JSON.parse(currentWorkflowItems);
    const config = JSON.parse(workflowItem.configuration);
    return stageList.map((stage: Stage) => {
      const newStage = config.configWidgetJSON.tasks.find((task: Stage) => task.id === stage.id);
      if (newStage) {
        const items = stage.items.map((item) => {
          const newItem = newStage.items.find((taskItem: TaskItem) => taskItem.id === item.id);
          if (newItem) return newItem;
          return item;
        });
        newStage['items'] = items;
        return newStage;
      }
      return stage;
    });
  }

  return stageList;
};

export const stageListMapper = (data: Stage[]): Stage[] => {
  let completedIndex: number;
  return data.map((stage, index) => {
    const items = checkFormsCompleted(stage.items);
    const completedStages = items.filter((item) => item.status === TaskItemStatus.COMPLETED);
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.status === TaskItemStatus.IN_PROGRESS || !item.status || item.status === TaskItemStatus.NOT_STARTED) {
        item.isActive = true;
        break;
      }
    }

    if (completedStages.length === items.length) {
      stage.status = TaskItemStatus.COMPLETED;
      completedIndex = index;
    }
    if (index !== 0) {
      const locked = !(completedStages.length === items.length || index === completedIndex + 1);
      return {
        ...stage,
        items: items,
        locked: locked,
        completed: isStageCompleted(stage.items),
      };
    }

    return {
      ...stage,
      items: items,
      locked: false,
      completed: isStageCompleted(stage.items),
    };
  });
};
